import actionTypes from '../constants/action-types';
import statuses from '../constants/statuses';

const status = (state = statuses.UNBLOCKED, action) => {
  switch (action.type) {
    case actionTypes.BLOCK: {
      return statuses.BLOCKED;
    }

    case actionTypes.UNBLOCK: {
      return statuses.UNBLOCKED;
    }

    default:
      return state;
  }
};

export default status;
